import type { LucideIcon } from "lucide-react";
import {
  Bell,
  Gift,
  IndianRupee,
  Package,
  ShoppingCart,
  Store,
  Truck,
  Users,
} from "lucide-react";
import { NotificationType } from "@/types/notification.dto";

export function formatNotificationRelativeTime(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} hr ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? "" : "s"} ago`;
}

export function getNotificationIcon(type: NotificationType): LucideIcon {
  switch (type) {
    case NotificationType.StoreApproval:
      return Store;
    case NotificationType.ProductApproval:
      return Package;
    case NotificationType.Order:
      return ShoppingCart;
    case NotificationType.Delivery:
      return Truck;
    case NotificationType.Referral:
      return Users;
    case NotificationType.Wallet:
    case NotificationType.Payment:
      return IndianRupee;
    case NotificationType.Promotion:
      return Gift;
    default:
      return Bell;
  }
}

export function getNotificationColor(type: NotificationType): string {
  switch (type) {
    case NotificationType.StoreApproval:
      return "text-primary bg-primary/10";
    case NotificationType.ProductApproval:
      return "text-accent bg-accent/10";
    case NotificationType.Order:
      return "text-info bg-info/10";
    case NotificationType.Delivery:
      return "text-warning bg-warning/10";
    case NotificationType.Payment:
    case NotificationType.Wallet:
      return "text-success bg-success/10";
    case NotificationType.Referral:
      return "text-primary bg-primary/10";
    case NotificationType.Promotion:
      return "text-accent bg-accent/10";
    default:
      return "text-muted-foreground bg-secondary";
  }
}

export function getNotificationTypeLabel(type: NotificationType): string {
  switch (type) {
    case NotificationType.Order:
      return "Order";
    case NotificationType.Payment:
      return "Payment";
    case NotificationType.Delivery:
      return "Delivery";
    case NotificationType.Referral:
      return "Referral";
    case NotificationType.Wallet:
      return "Wallet";
    case NotificationType.Promotion:
      return "Promotion";
    case NotificationType.System:
      return "System";
    case NotificationType.StoreApproval:
      return "Store";
    case NotificationType.ProductApproval:
      return "Product";
    default:
      return "Notification";
  }
}
